import MonthlyPackage from './MonthlyPackage';

export default MonthlyPackage;
